import * as React from 'react';
import { FormField } from '@cian/ui-kit';

import * as styles from './DobroFormField.css';

export interface IDobroFormFieldProps {
  label?: string;
  errorMessage?: string | null;
  required?: boolean;
  children: React.ReactElement;
  name: string;
}

export function DobroFormField(props: IDobroFormFieldProps) {
  return (
    <div data-name={props.name} className={styles.field}>
      <FormField label={props.label} required={props.required} errorMessage={props.errorMessage} withoutMargin>
        {props.children}
      </FormField>
    </div>
  );
}
